import { useState } from 'react';
import Dropdown from '../../../common/dropdown/Dropdown';
import { InfiniteScrollDropdown } from '../../../common/InfiniteScroll/InfiniteScrollDropdown';
import { DropdownFooter } from '../../../common/dropdown/DropdownFooter';

interface CustomDropdownProps {
  options: { id: number; label: string; image?: string; subtitle?: string }[];
  selectedId: number;
  onSelect: (id: number) => void;
  placeholder: string;
  hasSearch?: boolean;
  placement?: 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topRight' | 'top' | 'bottom' | 'left' | 'right';
  hasMore?: boolean;
  loadMore?: () => void;
  isLoading?: boolean;
  maxHeight?: string;
  searchPlaceholder?: string;
  onSearchSubmit?: (term: string) => void;
  useRemoteSearch?: boolean;
  variant?: 'text' | 'iconText' | 'iconTextDropdown' | 'customIconTextDropdown';
  isCardOption?: boolean;
  onDropdownOpen?: () => void;
  initialSearchTerm?: string;
}

export const CustomDropdown: React.FC<CustomDropdownProps> = ({
  options,
  selectedId,
  onSelect,
  placeholder,
  hasSearch = false,
  placement = 'bottomRight',
  hasMore = false,
  loadMore = () => { },
  isLoading = false,
  maxHeight = "300px",
  searchPlaceholder = "Search...",
  onSearchSubmit,
  useRemoteSearch,
  variant,
  isCardOption,
  onDropdownOpen,
  initialSearchTerm,
}) => {
  const [open, setOpen] = useState(false);
  const [pendingId, setPendingId] = useState(selectedId);

  const selectedOption = options.find(opt => opt.id === selectedId);
  const selectedLabel = selectedOption?.label || placeholder;
  const isActive = selectedId !== 0 && selectedId !== undefined && !!selectedOption;

  const handleToggle = (isOpen: boolean) => {
    if (isOpen) onDropdownOpen?.();
    setPendingId(selectedId);
    setOpen(isOpen);
  };

  const handleSelect = (id: number) => {
    setPendingId(id);
    onSelect(id);
    closeDropdown();
  };

  const closeDropdown = () => setTimeout(() => setOpen(false), 200);

  const getContent = () => (
    <div onClick={(e) => e.stopPropagation()}>
      <InfiniteScrollDropdown
        options={options}
        selectedId={pendingId}
        onSelect={handleSelect}
        hasSearch={hasSearch}
        hasMore={hasMore}
        loadMore={loadMore}
        isLoading={isLoading}
        maxHeight={maxHeight}
        searchPlaceholder={searchPlaceholder}
        onSearchSubmit={onSearchSubmit}
        useRemoteSearch={useRemoteSearch}
        isCardOption={isCardOption}
        initialSearchTerm={initialSearchTerm}
      />
      {/* <DropdownFooter title='Save' disabled={!pendingOption} onApply={handleSave} /> */}
    </div>
  );

  return (
    <Dropdown
      variant={variant || 'iconTextDropdown'}
      text={selectedLabel}
      content={getContent()}
      placement={placement}
      open={open}
      setOpen={handleToggle}
      isActive={isActive}
    />
  );
};
// e: React.MouseEvent<HTMLDivElement>